import React, {useState} from 'react';
import StudentLayout from "@/components/layout/student/studentLayout";
import ExamPage from "@/pages/student/lessons/exam/[id]/_section/ExamPage";

function StudentLessonExamPage(props) {
    const [backUrl, setBackUrl] = useState('')
    return (
        <StudentLayout pageTitle={'آزمون'} backTo={backUrl}>
            <ExamPage setBackUrl={setBackUrl}/>
        </StudentLayout>
    );
}

export default StudentLessonExamPage;